// extracted by mini-css-extract-plugin
export default {"bookingModalPromoRow":"row-booking-promo_bookingModalPromoRow__0ydLu"};